var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFechaduras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.75 18.25H18.5V1.75C18.5 1.35218 18.342 0.970644 18.0607 0.68934C17.7794 0.408035 17.3978 0.25 17 0.25H5C4.60218 0.25 4.22064 0.408035 3.93934 0.68934C3.65804 0.970644 3.5 1.35218 3.5 1.75V18.25H1.25C1.05109 18.25 0.860322 18.329 0.71967 18.4697C0.579018 18.6103 0.5 18.8011 0.5 19C0.5 19.1989 0.579018 19.3897 0.71967 19.5303C0.860322 19.671 1.05109 19.75 1.25 19.75H20.75C20.9489 19.75 21.1397 19.671 21.2803 19.5303C21.421 19.3897 21.5 19.1989 21.5 19C21.5 18.8011 21.421 18.6103 21.2803 18.4697C21.1397 18.329 20.9489 18.25 20.75 18.25ZM17 1.75V18.25H15.5V1.75H17ZM5 1.75H14V18.25H5V1.75ZM12.5 10.375C12.5 10.5975 12.434 10.815 12.3104 11C12.1868 11.185 12.0111 11.3292 11.8055 11.4144C11.6 11.4995 11.3738 11.5218 11.1555 11.4784C10.9373 11.435 10.7368 11.3278 10.5795 11.1705C10.4222 11.0132 10.315 10.8127 10.2716 10.5945C10.2282 10.3762 10.2505 10.15 10.3356 9.94448C10.4208 9.73891 10.565 9.56321 10.75 9.4396C10.935 9.31598 11.1525 9.25 11.375 9.25C11.6734 9.25 11.9595 9.36853 12.1705 9.5795C12.3815 9.79048 12.5 10.0766 12.5 10.375Z",
    fill: "#FAF8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFechaduras);
export default __webpack_public_path__ + "static/media/Fechaduras.95cb81b64ca5aa027e31b84b0828289a.svg";
export { ForwardRef as ReactComponent };